import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { isAccessTokenValid } from "../utils/validateToken";
import "../styles/profile.css";

const Profile = () => {
	const { firstname } = useSelector((state) => state.auth);
	const accessToken = localStorage.getItem("accessToken");
	const isValidToken = isAccessTokenValid(accessToken);
	const navigate = useNavigate();

	useEffect(() => {
		isValidToken ? navigate("/profile") : navigate("/signin");
	}, []);

	return (
		<div className="component_wrapper profile">
			<h2 className="sub_title"> Hello, {firstname}</h2>
			<p>
				Token: <span>	{`${accessToken?.substring(0, 10)}...${accessToken?.substring(accessToken.length - 10)}`}</span>
			</p>
			<p className="text_content">
				I’m a simple and a bit timid person, passionate in Web Development
				and 3d Technologies. I aim to refine my skills, learn new
				techniques, and deliver the best results.
			</p>
		</div>
	);
};

export default Profile;
